import { Input } from "antd";

interface Props {
  placeholder: string;
  onChange?: React.ChangeEventHandler<HTMLInputElement>;
  value: any;
  disabled?: boolean;
  estDecimals?: number | null;
  onBlur?: React.FocusEventHandler<HTMLInputElement> | undefined;
  onFocus?: React.FocusEventHandler<HTMLInputElement> | undefined;
}

const InputAmount = ({
  placeholder,
  onChange,
  value,
  disabled,
  estDecimals = 8,
  onBlur,
  onFocus,
}: Props) => {
  return (
    <Input
      placeholder={placeholder}
      onChange={onChange}
      value={value}
      onBlur={onBlur}
      onFocus={onFocus}
      onKeyDown={(e) => {
        const allowed = [
          "Backspace",
          "Delete",
          "ArrowLeft",
          "ArrowRight",
          "Tab",
        ];
        const key = e.key;
        const value = e.currentTarget.value;
        const hasDot = value.includes(".");
        const isDot = key === ".";
        const cursorPosition = e.currentTarget.selectionStart ?? 0;
        if (isDot) {
          if (value === "" || hasDot) {
            e.preventDefault();
          }
          return;
        }
        if (hasDot) {
          const dotIndex = value.indexOf(".");
          const decimals = value.substring(dotIndex + 1);
          if (
            cursorPosition > dotIndex &&
            decimals.length >= (estDecimals || 8) &&
            !allowed.includes(key)
          ) {
            e.preventDefault();
            return;
          }
        }
        if (!((key >= "0" && key <= "9") || allowed.includes(key))) {
          e.preventDefault();
        }
      }}
      disabled={disabled}
    />
  );
};

export default InputAmount;
